import { IParameter } from 'src/views/Links/types';

export const getParameterQueries = (parameters: IParameter[]) => {
  const checkedParameters = parameters
    .map(parameter => {
      return {
        name: parameter.name,
        values: parameter.values.map(value => value.value),
      };
    })
    .filter(parameter => parameter.values.length);

  return checkedParameters.map(({ name, values }) => {
    return {
      nested: {
        query: {
          bool: {
            filter: [
              {
                term: {
                  'parameters.Name': {
                    value: name,
                  },
                },
              },
              {
                terms: {
                  'parameters.Value': values,
                },
              },
            ],
          },
        },
        path: 'parameters',
        _name: 'param_nested',
        boost: 1.1,
      },
    };
  });
};



// WEBPACK FOOTER //
// ./src/services/api/links/utils/getParameterQueries.ts